import { Col, Row, Typography } from "antd";
import MazakaCard from "apps/Common/MazakaCart";

import { useEffect, useState } from "react";
import { useGetPageDetailsByPageType } from "./ServerSideStates";

import { Link } from "react-router-dom";
import StaticPageBanner from "apps/Common/StaticPageBanner";
import TruncatedText from "apps/Common/TruncatedText";
import PageTitle from "apps/Common/PageTitle";
import { Helmet } from "react-helmet-async";

const FAQIndex = () => {
  const { Text } = Typography;

  const pageDetails = useGetPageDetailsByPageType(1);
  const [groupDataList, setGroupDataList] = useState([]);

  useEffect(() => {
    if (pageDetails?.data?.data?.pageItem) {
      const data = pageDetails?.data?.data?.pageItem;

      const titles = data.filter((item: any) => item.isTitle === true);

      // Başlıkları, alt başlıklarla eşleştir
      const groupedData = titles.map((title: any) => ({
        name: title.name, // Ana başlık
        subTopics: data.filter(
          (item: any) =>
            item.isTitle === false && item.groupId === title.groupId
        ),
      }));
      setGroupDataList(groupedData);
    }
  }, [pageDetails?.data?.data]);

  return (
    <>
  
      <Col xs={24} className="!overflow-hidden" >
        <Row gutter={[20, 20]}>
          <Col xs={24}>
            <Row gutter={[20, 20]}>
              <Col xs={24}>
              <StaticPageBanner
              title= {pageDetails?.data?.data?.name}
              description= {pageDetails?.data?.data?.shortDescription || ""}
            />
             <Helmet>
                                                        <title className="capitalize">{"Sıkça Sorulan Sorular"}</title>
                                                  </Helmet>
                
              </Col>
             
              <Col xs={24}>
                <Row 
                gutter={[
                  { xs: 10, sm:20, md:25 , lg: 30,xl:35,xxl:40 }, 
                  { xs:10 ,sm:20, md: 25, lg: 30,xl:35,xxl:40 }   
                ]}
                
                className="!px-2 lg:!px-6 xxl:!px-16">
                  <Col xs={24}>
                    <Row gutter={[20, 20]}>
                      {groupDataList.map((item: any) => {
                        return (
                          <>
                            <MazakaCard
                              xs={24}
                              md={12}
                              lg={8}
                              gutter={[10, 10]}
                              className="!border !border-[#e2e5ea]"
                            >
                              <Col xs={24}>
                              <PageTitle
                              title= {item.name}
                          
                              />
                                
                              </Col>
                              <Col xs={24}>
                                <Row 
                                 gutter={[10,5]}
                                >
                                  {item.subTopics.map((subItem: any) => {
                                    return (
                                      <>
                                        <Col xs={24}>
                                          <Link to={`/sayfa/detay/${subItem.id}`} className="!text-[#0257c8] !text-xs sm:!text-sm">
                                            {subItem?.name}
                                          </Link>
                                        </Col>
                                      </>
                                    );
                                  })}
                                </Row>
                              </Col>
                            </MazakaCard>
                          </>
                        );
                      })}
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
     
    </>
  );
};

export default FAQIndex;
